import appRoutes from "@/routes";
import { Component } from "react";
import { NavLink } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-screen bg-red-500/10 text-2xl text-red-500 gap-5">
          <div className=" max-w-4xl mx-auto space-y-4">
            <p className="text-[200px] font-bold">Oops...</p>
            <h1 className="text-2xl md:text-4xl text-justify">
              Une erreur s&apos;est produite lors du chargement de la page.
              Veuillez recharger la page. Si le problème persiste, veuillez
              contacter l&apos;administrator
            </h1>
            <NavLink
              to={appRoutes.protected.dashboard}
              className="text-blue-500 hover:text-blue-600"
            >
              cliquez ici pour taller à la page d&apos;accueil
            </NavLink>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
